import { useState, useEffect } from 'react';
import { propertyService } from 'services/api';
import { useAuth } from 'context/AuthContext';
import PropertyCombobox from 'components/PropertyCombobox';
import styles from './PropertySelector.module.css';

/**
 * Selector de propiedad para super_admin.
 * Para admin no renderiza nada (ya tiene scope fijo).
 * Props:
 *   value        — property_id seleccionado (string o number)
 *   onChange     — fn(id) cuando cambia
 *   placeholder  — texto del option vacío
 */
export default function PropertySelector({ value, onChange, onChangeProperty, placeholder = '— Todas las propiedades —' }) {
  const { isSuperAdmin, user } = useAuth();
  const [properties, setProperties] = useState([]);
  const [loading, setLoading]       = useState(false);

  const isAdmin = user?.role === 'admin';

  useEffect(() => {
    if (!isSuperAdmin && !isAdmin) return;
    setLoading(true);
    propertyService.selector({ limit: 200 })
      .then(r => setProperties(r.data.data || []))
      .finally(() => setLoading(false));
  }, [isSuperAdmin, isAdmin]);

  // Super_admin: ver todas. Admin: solo ver si tiene más de 1 propiedad
  if (!isSuperAdmin && (!isAdmin || properties.length <= 1)) return null;

  return (
    <div className={styles.fila}>
      <i className={`fas fa-building ${styles.icono}`} />
      {loading ? (
        <div className={styles.cargando}>
          <div className={`spinner ${styles.spinnerChico}`} />
          Cargando...
        </div>
      ) : (
        <PropertyCombobox
          value={value}
          onChange={(id, propiedad) => {
            onChange(id);
            if (onChangeProperty) onChangeProperty(propiedad);
          }}
          placeholder={placeholder}
        />
      )}
      {value && (
        <button
          className={`btn btn-sm btn-secondary btn-icon ${styles.botonLimpiar}`}
          onClick={() => onChange('')}
          title="Limpiar filtro"
        >
          <i className="fas fa-times" />
        </button>
      )}
    </div>
  );
}